import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FetchAuthSessionUsecase } from '../application/usecases/fetch-auth-session/fetch-auth-session.usecase';
import { FetchUserAttributesUsecase } from '../application/usecases/fetch-user-attributes/fetch-user-attributes.usecase';
import { SignOutUsecase } from '../application/usecases/sign-out/sign-out.usecase';
import { AuthPort } from '../domain/ports/auth.port';
import { AuthAdapter } from './adapters/auth.adapter';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    {
      provide: FetchUserAttributesUsecase,
      useFactory: (authPort: AuthPort) =>
        new FetchUserAttributesUsecase(authPort),
      deps: [AuthPort],
    },
    {
      provide: FetchAuthSessionUsecase,
      useFactory: (authPort: AuthPort) => new FetchAuthSessionUsecase(authPort),
      deps: [AuthPort],
    },
    {
      provide: SignOutUsecase,
      useFactory: (authPort: AuthPort) => new SignOutUsecase(authPort),
      deps: [AuthPort],
    },
    { provide: AuthPort, useClass: AuthAdapter },
  ],
})
export class AuthInfrastructureModule {}
